<template>
    <comp-9-prep-adherence :section="9" :page="42" :nextDisabled="nextDisabled">
        <p>
            On a scale of 1 to 10 (with 10 being extremely ready), how ready are you to start taking PrEP regularly for the next 7 days?
        </p>
        <br />
        <br />
        <v-slider
            v-model="prepReadiness"
            min="1"
            max="10"
            step="1"
            track-color="primary"
            ticks="always"
            tick-size="2"
            always-dirty
            :tick-labels="tickLabels"
        ></v-slider>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
    data: function() {
        return {
            tickLabels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
        };
    },
    computed: {
        prepReadiness: sync('section9/prepReadiness')
    },
    methods: {
        nextDisabled() {
            return !this.prepReadiness;
        }
    }
};
</script>

<style scoped>
::v-deep .v-slider__ticks {
    border-color: var(--v-primary-base) !important;
}
</style>
